export interface HtmlPreviewSourceScrollTarget {
  maxScrollTop: number;
  sourceTop: number;
  viewportHeight: number;
  viewportRatio: number;
}

function clampRatio(ratio: number): number {
  if (!Number.isFinite(ratio)) return 0;
  return Math.min(1, Math.max(0, ratio));
}

function clampScrollTop(scrollTop: number, maxScrollTop: number): number {
  if (!Number.isFinite(scrollTop)) return 0;
  return Math.min(
    Math.max(0, maxScrollTop),
    Math.max(0, Math.round(scrollTop)),
  );
}

export function getHtmlPreviewSourceScrollTop({
  maxScrollTop,
  sourceTop,
  viewportHeight,
  viewportRatio,
}: HtmlPreviewSourceScrollTarget): number {
  return clampScrollTop(
    sourceTop - viewportHeight * clampRatio(viewportRatio),
    maxScrollTop,
  );
}
